import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSubscriberProfilePageStore } from 'store/pages/subscriber/subscriber-profile/pageStore';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';

const SubscriberProfileForm: React.FC = observer(() => {
  const { dynamicFormDelegate, isStepCompleted, returnBack } = useSubscriberProfilePageStore();

  return (
    <DynamicForm
      formDelegate={dynamicFormDelegate}
      completeButtonText={isStepCompleted ? 'Update' : 'Complete'}
      onBack={returnBack}
    />
  );
});

export default SubscriberProfileForm;
